export type ObservationPayload = Record<string, unknown>;

export function emitObservation(event: string, payload: ObservationPayload = {}): void {
  const envelope = {
    event,
    timestamp: new Date().toISOString(),
    ...payload,
  };

  try {
    // Keep runtime-visible diagnostics without coupling functional logic to logging.
    console.info('[enfa-client-observe]', JSON.stringify(envelope));
  } catch {
    console.info('[enfa-client-observe]', event);
  }
}
